// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"eb5b03ed","166":"5751a703","182":"bb006132","241":"c0cf4c6f","309":"6b23df7a","370":"a1f4d75e","418":"9d7f33e6","419":"ed773d81","638":"afe092c8","989":"04923659"}[chunkId] + ".chunk.js";
};